import React from 'react';
import styled from 'styled-components';
import { ReactComponent as CloseIcon } from 'assets/icon/close.svg';

const StyledButton = styled.button`
  background: none;
  border: none;
  outline: none;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

interface Props {
  onClick: () => void;
}

const CloseIconButton = ({ onClick }: Props) => {
  return (
    <StyledButton data-test-id="close-icon-btn" onClick={onClick}>
      <CloseIcon />
    </StyledButton>
  );
};

export default CloseIconButton;
